module.exports = __webpack_public_path__ + "img/bank.be5030ca.webp";